import React from 'react';
import ReactDOM from 'react-dom';
import App from './public/app'
// import './fonts/BlahBlahBlah.otf'

ReactDOM.render(
      <App/>,
    document.getElementById('root')
  );